<template>
  <div>
    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      :title="(isEditWorkFlow ? 'Update ' : isDuplicateWorkFlow ? 'Duplicate ' : 'Add New ') + ' Workflow Setting'"
      size="xl"
      scrollable
      v-model="showAddModal"
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <b-tabs
            small
            card
            fill
          >
            <b-tab
              title="Setup"
              class="text-left"
            >
              <b-row>
                <b-col cols="6">
                  <b-form-group
                    label="Title"
                    description="Please enter a title"
                  >
                    <b-form-input
                      size="sm"
                      type="text"
                      v-model="$v.form.title.$model"
                      :state="$v.form.title.$dirty ? !$v.form.title.$error : null"
                      @input="setTitleValue"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Version"
                    description="Please enter a version"
                  >
                    <b-form-input
                      size="sm"
                      type="text"
                      v-model="$v.form.version.$model"
                      :state="$v.form.version.$dirty ? !$v.form.version.$error : null"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row
                v-if="form.title"
                class="mt-4"
              >
                <b-col cols="6">
                  <b-form-group>
                    <b-form-checkbox
                      inline
                      v-model="selectedLanguage"
                      v-for="(language,index) in languagesOptions"
                      :key="index"
                      :value="language"
                      :disabled="language.text == 'English' ? true : false"
                    >{{language.text}}</b-form-checkbox>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Approval Types">
                    <b-form-checkbox
                      inline
                      v-model="selectedApprovalType"
                      v-for="(type,index) in approvalTypesOptions"
                      :key="index"
                      :value="type"
                      @input="setApprovalTypesTabs"
                    >{{type.text}}</b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab
              :title="tab.text"
              v-for="(tab,tabIndex) in selectedApprovalType"
              :key="tabIndex"
              @click="setEmailLanguages(tabIndex)"
            >
              <AddModalComponents
                :selectedLanguage="selectedLanguage"
                :approvalTypeIndex="tabIndex"
                :emailTagsOptions="emailTagsOptions"
                :platformSettingOptions="platformSettingOptions"
              />
            </b-tab>
          </b-tabs>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>{{ isEditWorkFlow ? 'Your Workflow is being Updating......' : isDuplicateWorkFlow ? 'Your Workflow is being duplicating......' : 'Your Workflow is being Creating......'}}</p>
          <b-spinner
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            {{ isEditWorkFlow ? 'Your Workflow has been updated successfully.' : isDuplicateWorkFlow ? 'Your Workflow has been Duplicated successfully.' : 'Your Workflow has been added successfully.'}}
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button
          v-if="!submiting"
          @click="closeModal"
          variant="outline-danger"
        >Close</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          @click="checkValidation"
          variant="outline-success"
        >{{ isEditWorkFlow ? 'Update' : isDuplicateWorkFlow ? 'Duplicate' : 'Save '}}</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { HTTP } from "../../../../utils/HTTP";
import { EventBus } from "@/event-bus.js";
import AddModalComponents from "./modalComponents/addModalComponents.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "AddGiftModal",
  mixins: [validationMixin],
  components: {
    AddModalComponents,
  },
  data () {
    return {
      selectedLanguage: [{ text: "English", value: "1" }],
      submiting: false,
      responseSuccess: false,
      isLoading: false,
      showAddModal: false,
      selectedApprovalType: [],
      approvalTypesOptions: [],
      emailTagsOptions: [],
      platformSettingOptions: [],
      form: {
        title: null,
        version: null,
      },
      workflowSettingId: null,
      isEditWorkFlow: false,
      languagesOptions: [],
      editConfigrationData: [],
      isDuplicateWorkFlow: false,
      selectedLanguageLenght: null,
      setupEmails: {},
      // showSelect: []
    };
  },
  validations: {
    form: {
      title: { required },
      version: { required },
    },
  },
  created () {
    EventBus.$on( "onShowAddGiftModal", ( value ) => {
      this.showAddGiftModal();
    } );
    EventBus.$on( "onShowEditGiftWorkflowModal", ( value ) => {
      this.showEditWorkflowModal( value );
    } );
    EventBus.$on( "onShowDuplicateGiftWorkflowSettingModal", ( value ) => {
      this.showDuplicateWorkflowModal( value );
    } );
  },
  mounted () {
    this.getEmployeeLanguages();
    this.getApprovalTypesList();
    this.getEmailTagsList();
    this.getPlatformSettingList();
  },
  methods: {
    setEmailLanguages ( tabIndex ) {
      if ( this.$store.state.approvalModalCategories[tabIndex].emails == null ) {
        this.selectedLanguageLenght = this.selectedLanguage.length;
        this.selectedLanguage.map( ( languages ) => {
          let language = languages.value;
          this.setupEmails[language] = {
            newGiftRequest: {
              subject: null,
              message: null,
            },
            newApproverRequestEmail: {
              subject: null,
              message: null,
            },
            approverReminderEmail: {
              subject: null,
              message: null,
            },
            approvalEmail: {
              subject: null,
              message: null,
            },
            rejectedEmail: {
              subject: null,
              message: null,
            },
            additionalInfoEmail: {
              subject: null,
              message: null,
            },
          };
          this.$store.state.approvalModalCategories[
            tabIndex
          ].emails = this.setupEmails;
        } );
      } else if (
        this.selectedLanguageLenght != this.selectedLanguage.length &&
        this.$store.state.approvalModalCategories[tabIndex].emails != null
      ) {
        this.$store.state.approvalModalCategories[tabIndex].emails = null;
        this.selectedLanguage.map( ( languages ) => {
          let language = languages.value;
          this.setupEmails[language] = {
            newGiftRequest: {
              subject: null,
              message: null,
            },
            newApproverRequestEmail: {
              subject: null,
              message: null,
            },
            approverReminderEmail: {
              subject: null,
              message: null,
            },
            approvalEmail: {
              subject: null,
              message: null,
            },
            rejectedEmail: {
              subject: null,
              message: null,
            },
            additionalInfoEmail: {
              subject: null,
              message: null,
            },
          };
          this.$store.state.approvalModalCategories[
            tabIndex
          ].emails = this.setupEmails;
        } );
      }
    },
    showDuplicateWorkflowModal ( value ) {
      this.isDuplicateWorkFlow = true;
      this.workflowSettingId = value.id;
      this.form = {
        title: value.title,
        version: value.version,
      };
      let configurationData = JSON.parse( value.configuration );
      this.editConfigrationData = [];
      this.$store.state.approvalModalCategories = [];
      if ( configurationData.selectedApprovalType.length > 0 ) {
        configurationData.selectedApprovalType.map( ( types ) => {
          this.selectedApprovalType.push( types );
        } );
      }
      if ( configurationData.languages.length > 0 ) {
        this.selectedLanguage = [];
        this.selectedLanguageLenght = null;
        this.selectedLanguageLenght = configurationData.languages.length;
        configurationData.languages.map( ( language ) => {
          this.selectedLanguage.push( language );
        } );
      }
      if ( configurationData.categories.length > 0 ) {
        configurationData.categories.map( ( categorieData ) => {
          this.editConfigrationData.push( categorieData.settings );
        } );
        this.editConfigrationData.map( ( data ) => {
          this.$store.state.approvalModalCategories.push( data );
        } );
      }
      this.showAddModal = true;
    },
    showEditWorkflowModal ( value ) {
      this.isEditWorkFlow = true;
      this.workflowSettingId = value.id;
      this.form = {
        title: value.title,
        version: value.version,
      };
      let configurationData = JSON.parse( value.configuration );
      this.editConfigrationData = [];
      this.$store.state.approvalModalCategories = [];
      if ( configurationData.selectedApprovalType.length > 0 ) {
        configurationData.selectedApprovalType.map( ( types ) => {
          this.selectedApprovalType.push( types );
        } );
      }
      if ( configurationData.languages.length > 0 ) {
        this.selectedLanguage = [];
        this.selectedLanguageLenght = null;
        this.selectedLanguageLenght = configurationData.languages.length;
        configurationData.languages.map( ( language ) => {
          this.selectedLanguage.push( language );
        } );
      }
      if ( configurationData.categories.length > 0 ) {
        configurationData.categories.map( ( categorieData ) => {
          this.editConfigrationData.push( categorieData.settings );
        } );
        this.editConfigrationData.map( ( data ) => {
          this.$store.state.approvalModalCategories.push( data );
        } );
      }
      this.showAddModal = true;
    },
    setApprovalTypesTabs () {
      this.selectedApprovalType.map( ( value ) => {
        this.setApprovalTypesValue();
      } );
    },
    setApprovalTypesValue () {
      this.$store.state.approvalModalCategories.push( {
        configration: {
          showApprovers: false,
          showConditions: false,
          showEmail: false,
          emailTags: this.emailTagsOptions,
          platformSettings: this.platformSettingOptions,
        },
        approvers: {
          requierApprover: null,
          approversList: [],
        },
        conditions: {
          selectedCurrency: null,
          currencyValue: null,
          maximumAmount: [2],
          numberOfApproverValue: [],
        },
        emails: null,
      } );
    },
    async getEmployeeLanguages () {
      this.languagesOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/constants/languages-list", null );
        this.languagesOptions = result.data.employeeLanuages;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getApprovalTypesList () {
      this.approvalTypesOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/approvals/type/list", null );
        this.approvalTypesOptions = result.data.approvalTypes;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getEmailTagsList () {
      this.emailTagsOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/tag/list", null );
        this.emailTagsOptions = result.data.emailTags;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getPlatformSettingList () {
      this.platformSettingOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/platform/list", null );
        if ( result.data[0].platform_variables ) {
          let settings = JSON.parse( result.data[0].platform_variables );
          this.platformSettingOptions = settings;
        }
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    showAddGiftModal () {
      this.showAddModal = true;
    },
    setTitleValue ( value ) {
      if ( value ) {
        return "";
      } else if ( value == null ) {
        this.selectedApprovalType = [];
        this.selectedLanguage = [];
        this.$store.state.approvalModalCategories = [];
      }
    },
    closeModal () {
      this.showAddModal = false;
      this.editConfigrationData = [];
      this.workflowSettingId = null;
      this.isEditWorkFlow = false;
      this.isDuplicateWorkFlow = false;
      this.selectedApprovalType = [];
      this.form = {
        title: null,
        version: null,
      };
      this.selectedLanguage = [{ text: "English", value: "1" }];
      this.$store.state.approvalModalCategories = [];
      this.selectedLanguageLenght = null;
      this.submiting = false;
      this.isLoading = false;
      this.responseSuccess = false;
    },
    reloadTable () {
      this.$root.$emit( "bv::refresh::table", "gifts-table" );
    },
    checkValidation () {
      this.$v.form.$touch();
      if ( this.$v.form.$anyError ) {
        return;
      } else if ( this.isEditWorkFlow ) {
        this.updateGiftWorkFlow().then( this.reloadTable );
      } else {
        this.saveGiftWorkFlow().then( this.reloadTable );
      }
    },
    async updateGiftWorkFlow () {
      let formData = {
        user_id: localStorage.getItem( "userId" ),
        workflow_setting_id: this.workflowSettingId,
        title: this.form.title,
        version: this.form.version,
        workflow_type_id: 1,
        configuration: {
          selectedApprovalType: this.selectedApprovalType,
          languages: this.selectedLanguage,
          categories: this.selectedApprovalType.map( ( types, index ) => {
            return {
              title: types.text,
              id: types.value,
              settings: this.$store.state.approvalModalCategories[index],
            };
          } ),
        },
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        await HTTP( "post", "api/v1/workflow/settings/update", formData );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch ( err ) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
    async saveGiftWorkFlow () {
      let formData = {
        user_id: localStorage.getItem( "userId" ),
        title: this.form.title,
        version: this.form.version,
        workflow_type_id: 1,
        configuration: {
          selectedApprovalType: this.selectedApprovalType,
          languages: this.selectedLanguage,
          categories: this.selectedApprovalType.map( ( types, index ) => {
            return {
              title: types.text,
              id: types.value,
              settings: this.$store.state.approvalModalCategories[index],
            };
          } ),
        },
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        await HTTP( "post", "api/v1/workflow/settings/create", formData );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch ( err ) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
  },
};
</script>